<template>
    <div class="mb-5">
        <h5 class="card-title">Perks</h5>
        <div class="row">
            <a class="col-md-6 mb-3 mb-md-4" v-for="perk in displayPerks" :key="perk.id" v-router-link="{name: 'PerkDetail', params: { id: perk.perk.id }}">
                <div class="card">
                    <div class="picture" :style="{ backgroundImage: `url(${ perk.perk.company.picture })`}">
                        <img class="sr-only" :src="perk.perk.company.picture" :alt="perk.perk.company.name">
                    </div>
                    <div class="content">
                        <h6>{{ perk.perk.company.name }}</h6>
                        <p>{{ perk.perk.description | truncate(50, '...') }}</p>
                    </div>
                </div>
            </a>
        </div>
      
        <see-more-button
            v-if="perks.length > 2"
            :count="perks.length - 2"
            @showMore="(status) => showMore = status"
        ></see-more-button>
    </div>
</template>

<script>
import SeeMoreButton from  '../global/SeeMoreButton';

export default {
    name: 'network-perks-card',

    components: {
        SeeMoreButton,
    },

    props: {
        perks: {
            type: Array,
            default() {
                return [];
            }
        }
    },

    data() {
        return {
            showMore: false,
        }
    },

    computed: {
        displayPerks() {
            return (this.showMore) ? this.perks : this.perks.slice(0, 2);
        }
    }
}
</script>

<style lang="scss" scoped>
    .card {
        display: flex;
        flex-direction: row;
        padding: 25px;
        height: 100%;
    }

    h6 {
        font-size: 17px;
        font-weight: 700;
    }

    .picture {
        width: 42px;
        height: 42px;
        border-radius: 50%;
        background-color: $grey;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: top center;
        overflow: hidden;

        @include media-breakpoint-up(md) {
            width: 60px;
            height: 60px;
        }
        @include media-breakpoint-up(lg) {
            width: 82px;
            height: 82px;
        }
    }

    .content {
        width: 78%;
        margin-left: 15px;

        @include media-breakpoint-up(lg) {
            width: 68%;
        }
        p {
            margin-bottom: 0;
            font-size: 15px;
            color: #505B64;
            line-height: 21px;
        }
    }
</style>
